/**
 * 收敛stroefont 相关方法类
 * stroefont链接示例：`https://www.didi-food.com/${locale}/food/store/:storeId?/:shopName?/?cityId=&promotionChannel=SF`
 */

import qs from '@/utils/urlParam';
import router from '@/router';

const PromotionChannel = 'promotionChannel';
const CityId = 'cityId';

const SF = 'SF';
class LS {
  set(key, value) {
    return sessionStorage?.setItem(key, value);
  }

  get(key) {
    return sessionStorage?.getItem(key);
  }

  del(key) {
    return sessionStorage?.removeItem(key);
  }
}

const ls = new LS();
class StoreFont {
  constructor() {
    this.storage = ls;
  }
  isStoreFont() {
    const promotionChannel = this.getPromotionChannel();
    return promotionChannel === SF || this.storage.get(PromotionChannel) === SF;
  }
  getStoreFontCityId() {
    const CityId = qs(CityId);
    return CityId || this.storage.get(CityId);
  }
  watchQueryChange(query) {
    const queryStr = query[PromotionChannel];
    const storageStr = this.storage.get(PromotionChannel);

    if (storageStr) {
      this.setQuery(storageStr, query);
      return;
    }

    if (queryStr) {
      this.setStorage(queryStr);
      return;
    }
    // TODO URL和本地缓存信息都失效时的处理逻辑
  }
  setQuery(str, restQuery) {
    const currentQuery = router?.app?._route?.query || {};
    const currentHash = router?.app?._route?.hash || '';

    restQuery = restQuery || currentQuery;
    router
      .replace({
        query: { ...restQuery, promotionChannel: str },
        hash: currentHash,
      })
      .catch((err) => {
        // console.log('===========  router replace err ===========', err);
      });
  }

  setStorage(str) {
    this.storage.set(PromotionChannel, str);
  }

  getPromotionChannel() {
    return qs(PromotionChannel) || '';
  }
  getShopId() {
    const match = window.location?.href?.match(/\/store\/(\d+)/);
    if (match && match[1]) {
      return match[1];
    }
    return null;
  }
}

const storeFont = new StoreFont();
export default storeFont;
